import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, FileText } from 'lucide-react';
import { COMPANY_INFO } from '../lib/utils';
import { WHATSAPP_INTL, WHATSAPP_NUMBER } from '../lib/cities-data';

const WA_TEXT = encodeURIComponent("Bonjour Ptitservices, je souhaite des informations sur vos services à domicile (ménage / jardinage) et le crédit d'impôt en avance immédiate.");
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_INTL}?text=${WA_TEXT}`;
export const WHATSAPP_DISPLAY = WHATSAPP_NUMBER.replace(/(\d{2})(?=\d)/g, '$1 ');

export default function FloatingContact() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin') || pathname.startsWith('/easer') || pathname.startsWith('/client')) return null;

  const trackClick = (label) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'contact_click', { method: label, page_path: pathname });
    }
  };

  return (
    <>
      {/* Desktop / tablet: floating WhatsApp button (bottom-right) */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackClick('whatsapp')}
        aria-label={`Discuter sur WhatsApp au ${WHATSAPP_DISPLAY}`}
        data-testid="floating-whatsapp-desktop"
        className="hidden md:flex fixed bottom-5 right-5 z-[60] items-center gap-2 pl-3 pr-4 h-12 rounded-full bg-[hsl(var(--primary))] text-white shadow-lg hover:bg-[hsl(var(--primary))]/90 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] transition-[transform,background-color] duration-200"
      >
        <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-white/15">
          <MessageCircle className="h-5 w-5" />
          <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-[hsl(var(--accent))] ring-2 ring-[hsl(var(--primary))]" />
        </span>
        <span className="text-sm font-semibold">WhatsApp</span>
      </a>

      {/* Mobile: sticky bottom action bar */}
      <div
        className="md:hidden fixed bottom-0 left-0 right-0 z-[60] border-t border-border bg-card/95 backdrop-blur-md shadow-[0_-4px_20px_-8px_rgba(0,0,0,0.15)]"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        data-testid="floating-contact-bar"
      >
        <div className="grid grid-cols-3 divide-x divide-border">
          <a
            href={`tel:${COMPANY_INFO.phoneRaw}`}
            onClick={() => trackClick('phone')}
            data-testid="floating-call-button"
            className="flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[hsl(var(--primary))] active:bg-[hsl(var(--secondary))] focus-visible:outline-none focus-visible:bg-[hsl(var(--secondary))]"
          >
            <Phone className="h-5 w-5" />
            <span className="text-[11px] font-semibold">Appeler</span>
          </a>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick('whatsapp')}
            data-testid="floating-whatsapp-button"
            className="flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[hsl(var(--primary))] active:bg-[hsl(var(--secondary))] focus-visible:outline-none focus-visible:bg-[hsl(var(--secondary))]"
          >
            <MessageCircle className="h-5 w-5" />
            <span className="text-[11px] font-semibold">WhatsApp</span>
          </a>
          <Link
            to="/devis"
            onClick={() => trackClick('devis')}
            data-testid="floating-quote-button"
            className="flex flex-col items-center justify-center gap-0.5 min-h-[56px] bg-[hsl(var(--accent))] text-white active:bg-[hsl(var(--accent))]/90 focus-visible:outline-none"
          >
            <FileText className="h-5 w-5" />
            <span className="text-[11px] font-semibold">Devis gratuit</span>
          </Link>
        </div>
      </div>
      {/* Spacer so page content is not hidden behind the mobile bar */}
      <div className="md:hidden h-[56px]" aria-hidden="true" />
    </>
  );
}
